<div class="text-area text-body1"
     [class.error-border]="hasError()">
<textarea
  style="
  width: 100%;
  min-height: 126px;
border: none;
 outline: none;
 font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
  letter-spacing: 0.32px;"
  [placeholder]="placeholder"
  [(ngModel)]="value"
  (ngModelChange)="onValueChanged($event)"
  [attr.maxLength]="maxLetterCount"
></textarea>
  <div class="word-count" [class.error-font-color]="(value?.length || 0) >= maxLetterCount">
    {{ value?.length || 0 }}/{{ maxLetterCount }}
  </div>
</div>
